// Rahaty Store — COD Checkout Script
const COD_CONFIG = {
  // Replace this with your Google Sheets Apps Script Web App Webhook URL
  webhookUrl: 'https://script.google.com/macros/s/AKfycbyo9ktXNguQdPbVDbipypdY9EqVkXrj3wcW2dwFWB5X-ZFM4fGNPXxbM2FdYM2PCgPD/exec',
  get thankYouPageUrl() {
    const rootUrl = window.RAHATY_SETTINGS?.rootUrl || '/';
    const baseUrl = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
    return baseUrl + '/pages/thank-you';
  }
};
window.COD_CONFIG = COD_CONFIG;

function formatPhone(raw) {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('00971')) {
    digits = digits.slice(2);
  }
  if (digits.startsWith('05')) {
    digits = '971' + digits.slice(1);
  }
  return digits;
}

function formatProductNames(cartItems) {
  return cartItems.map(item => item.product_title || item.title).join('/');
}

function formatSKUs(cartItems) {
  return cartItems.map(item => item.sku || '').join('/');
}

function formatQuantities(cartItems) {
  return cartItems.map(item => item.quantity).join('/');
}

// --- Storewide Bundle Pricing Engine ---
function getProductPricing(item, cartItems) {
  const h = (item.handle || '').toLowerCase();
  const t = (item.product_title || item.title || '').toLowerCase();
  const varId = Number(item.variant_id || item.id);

  // Check if it's a free gift / test variant
  const isGift = h === 'gift' || h === 'test' || varId === 46726615990444 || varId === 53127526154551 || t.includes('هدية') || t.includes('free gift') || item.price === 0;
  if (isGift) {
    return { unitPrice: 0, linePrice: 0, isGift: true };
  }

  // Determine product category
  let prodType = null;
  if (h.includes('tooth-cleaner') || h.includes('cleaner') || t.includes('جير') || (t.includes('تنظيف') && t.includes('أسنان')) || t.includes('منظف الأسنان')) {
    prodType = 'cleaner';
  } else if (h.includes('flosser') || t.includes('flosser') || t.includes('خيط') || (t.includes('أسنان') && !t.includes('جير')) || t.includes('المائي')) {
    prodType = 'flosser';
  } else if (h === 'video-walkie-talkie' || h.includes('walkie') || t.includes('walkie') || (t.includes('لاسلكي') && (t.includes('أطفال') || t.includes('فيديو') || t.includes('شاشة') || !t.includes('خيط')))) {
    prodType = 'walkie';
  } else if (h === 'security-camera' || h.includes('camera') || t.includes('مراقبة') || (t.includes('كاميرا') && !t.includes('لاسلكي'))) {
    prodType = 'camera';
  } else if (h === 'k-massager' || h.includes('massager') || t.includes('تدليك الركبة') || t.includes('مساج الركبة')) {
    prodType = 'kmassager';
  } else if (h.includes('drum-paint') || t.includes('drum-paint') || t.includes('رول الدهان') || t.includes('دهان')) {
    prodType = 'drum-paint';
  } else if (h.includes('drawing-board') || t.includes('drawing-board') || t.includes('لوحة الرسم') || t.includes('لوح الرسم')) {
    prodType = 'drawing-board';
  } else if (h.includes('beberon') || t.includes('beberon') || t.includes('تسخين') || t.includes('راحة الأم')) {
    prodType = 'beberon';
  } else if (h.includes('belty') || t.includes('belty') || t.includes('حزام') || t.includes('تدفئة')) {
    prodType = 'belty';
  } else if (h.includes('correctly') || h.includes('posture-corrector') || t.includes('مشد') || t.includes('وضعية')) {
    prodType = 'correctly';
  } else if (h.includes('revitaleyes') || t.includes('revitaleyes')) {
    prodType = 'revitaleyes';
  }

  // Compute total quantity of this product type across all items in cart (excluding free gifts)
  let totalQty = 0;
  if (prodType && Array.isArray(cartItems)) {
    cartItems.forEach(ci => {
      const ch = (ci.handle || '').toLowerCase();
      const ct = (ci.product_title || ci.title || '').toLowerCase();
      const cVarId = Number(ci.variant_id || ci.id);
      if (ch === 'gift' || ch === 'test' || cVarId === 46726615990444 || cVarId === 53127526154551 || ct.includes('هدية') || ci.price === 0) return;

      if (prodType === 'cleaner' && (ch.includes('tooth-cleaner') || ch.includes('cleaner') || ct.includes('جير') || (ct.includes('تنظيف') && ct.includes('أسنان')) || ct.includes('منظف الأسنان'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'flosser' && (ch.includes('flosser') || ct.includes('flosser') || ct.includes('خيط') || (ct.includes('أسنان') && !ct.includes('جير')) || ct.includes('المائي'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'walkie' && (ch === 'video-walkie-talkie' || ch.includes('walkie') || ct.includes('walkie') || (ct.includes('لاسلكي') && !ct.includes('خيط')))) {
        totalQty += ci.quantity;
      } else if (prodType === 'camera' && (ch === 'security-camera' || ch.includes('camera') || ct.includes('مراقبة') || (ct.includes('كاميرا') && !ct.includes('لاسلكي')))) {
        totalQty += ci.quantity;
      } else if (prodType === 'kmassager' && (ch === 'k-massager' || ch.includes('massager') || ct.includes('تدليك الركبة') || ct.includes('مساج الركبة'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'drum-paint' && (ch.includes('drum-paint') || ct.includes('drum-paint') || ct.includes('رول الدهان') || ct.includes('دهان'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'drawing-board' && (ch.includes('drawing-board') || ct.includes('drawing-board') || ct.includes('لوحة الرسم') || ct.includes('لوح الرسم'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'beberon' && (ch.includes('beberon') || ct.includes('beberon') || ct.includes('تسخين') || ct.includes('راحة الأم'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'belty' && (ch.includes('belty') || ct.includes('belty') || ct.includes('حزام') || ct.includes('تدفئة'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'correctly' && (ch.includes('correctly') || ch.includes('posture-corrector') || ct.includes('مشد') || ct.includes('وضعية'))) {
        totalQty += ci.quantity;
      } else if (prodType === 'revitaleyes' && (ch.includes('revitaleyes') || ct.includes('revitaleyes'))) {
        totalQty += ci.quantity;
      }
    });
  } else {
    totalQty = item.quantity;
  }

  // Calculate unit price from tiers
  let unitPrice = (item.final_line_price || item.price || 0) / (item.quantity || 1) / 100;
  if (prodType === 'camera' || prodType === 'revitaleyes') {
    if (totalQty === 2) unitPrice = 219.95;
    else if (totalQty >= 3) unitPrice = 199.95;
    else unitPrice = 249.95;
  } else if (prodType === 'walkie') {
    if (totalQty === 2) unitPrice = 159.95;
    else if (totalQty >= 3) unitPrice = 139.95;
    else unitPrice = 179.95;
  } else if (prodType === 'kmassager') {
    if (totalQty === 2) unitPrice = 179.95;
    else if (totalQty >= 3) unitPrice = 159.95;
    else unitPrice = 199.95;
  } else if (prodType === 'cleaner') {
    if (totalQty === 2) unitPrice = 119.95;
    else if (totalQty >= 3) unitPrice = 109.95;
    else unitPrice = 129.95;
  } else if (prodType === 'drum-paint' || prodType === 'drawing-board' || prodType === 'beberon' || prodType === 'belty') {
    if (totalQty === 2) unitPrice = 109.95;
    else if (totalQty >= 3) unitPrice = 99.95;
    else unitPrice = 119.95;
  } else if (prodType === 'flosser' || prodType === 'correctly') {
    if (totalQty === 2) unitPrice = 119.95;
    else if (totalQty >= 3) unitPrice = 99.95;
    else unitPrice = 129.95;
  }

  const linePrice = unitPrice * item.quantity;
  return { unitPrice, linePrice, isGift: false };
}

// Global modal trigger helper
window.ppcOpenCodModal = function(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  const drawer = document.querySelector('cart-drawer, .cart-drawer, cart-drawer-component');
  if (drawer) {
    if (typeof drawer.close === 'function') drawer.close();
    else if (typeof drawer.closeDialog === 'function') drawer.closeDialog();
    else {
      drawer.classList.remove('is-active', 'active');
      const dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.close === 'function') dialog.close();
    }
  }
  document.body.classList.remove('overflow-hidden');

  const modal = document.querySelector('#cod-checkout-modal');
  if (!window.CodCheckoutInstance && typeof CodCheckout === 'function') {
    window.CodCheckoutInstance = new CodCheckout();
  }
  if (window.CodCheckoutInstance && typeof window.CodCheckoutInstance.openModal === 'function') {
    window.CodCheckoutInstance.openModal(modal);
  } else if (modal) {
    if (typeof modal.showDialog === 'function') modal.showDialog();
    else {
      const nativeDialog = modal.querySelector('dialog');
      if (nativeDialog) {
        if (typeof nativeDialog.showModal === 'function') nativeDialog.showModal();
        else nativeDialog.setAttribute('open', 'true');
      }
    }
  }
};

class CodCheckout {
  constructor() {
    this.modal = document.querySelector('#cod-checkout-modal');
    this.form = document.querySelector('#cod-checkout-form');
    this.itemsList = document.querySelector('#cod-items-list');
    this.totalPriceEls = document.querySelectorAll('.cod-total-price');
    this.submitBtn = document.querySelector('#CodSubmitBtn');
    this.errorAlert = document.querySelector('#cod-form-error');
    
    this.cartData = null;
    this.isSubmitted = false;
    this.init();
  }

  handleCheckoutClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    // Close the cart drawer if it is open
    const drawer = document.querySelector('cart-drawer, .cart-drawer, cart-drawer-component');
    if (drawer) {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else if (typeof drawer.closeDialog === 'function') {
        drawer.closeDialog();
      } else {
        drawer.classList.remove('is-active', 'active');
        const dialog = drawer.querySelector('dialog');
        if (dialog && typeof dialog.close === 'function') {
          dialog.close();
        }
      }
    }
    document.body.classList.remove('overflow-hidden');

    // Open COD Popup
    this.openModal(this.modal);
  }

  init() {
    if (!this.modal || !this.form) return;

    // Listen for dialog open event dispatched by DialogComponent class
    this.modal.addEventListener('dialog:open', () => {
      this.isSubmitted = false;
      this.loadCartData();
    });
    
    // Intercept form submission
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    
    // Initialize Phone field live validator
    this.initPhoneValidator();

    // Intercept any checkout button click in capture phase to guarantee interception
    document.addEventListener('click', (e) => {
      // Exclude dynamic checkout / online payment buttons
      if (e.target.closest('#CartDrawer-PayOnline, #CartDrawer-SmartPayOnline, .cart__checkout-button--smart-online, .shopify-payment-button, .express-checkout-buttons')) {
        return;
      }

      const checkoutBtn = e.target.closest('#CartDrawer-Checkout, .cart__checkout-button--cod, [data-cod-checkout], [name="checkout"]');
      if (checkoutBtn) {
        this.handleCheckoutClick(e);
      }
    }, true);

    // Prevent accidental standard cart form submissions to Shopify online checkout
    document.addEventListener('submit', (e) => {
      if (e.target.matches('#CartDrawer-Form, .cart-drawer__form')) {
        if (e.submitter && e.submitter.closest('#CartDrawer-PayOnline, #CartDrawer-SmartPayOnline, .cart__checkout-button--smart-online')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.handleCheckoutClick(e);
      }
    }, true);

    // Intercept product page CTA buttons (COD primary buttons)
    document.addEventListener('click', async (e) => {
      // Exclude dynamic checkout / online payment buttons
      if (e.target.closest('.shopify-payment-button, .express-checkout-buttons, #CartDrawer-PayOnline, #CartDrawer-SmartPayOnline, .cart__checkout-button--smart-online')) {
        return;
      }

      const productCtaBtn = e.target.closest('.atc-button, .main-product-atc, .rev-submit-btn, [data-cod-trigger="true"], .bss-cta-button:not(.bss-banner-btn):not(.bss-final-btn):not(.bss-sticky-btn)');
      if (productCtaBtn) {
        e.preventDefault();
        e.stopPropagation();

        const form = productCtaBtn.closest('form');
        let variantId = null;
        let quantity = 1;
        let properties = {};

        if (form) {
          const idInput = form.querySelector('input[name="id"], .product-variant-id');
          if (idInput && idInput.value) {
            variantId = idInput.value;
          }
          const qtyInput = form.querySelector('input[name="quantity"], .quantity__input, .product-quantity-input');
          if (qtyInput && qtyInput.value) {
            quantity = parseInt(qtyInput.value, 10) || 1;
          }
          form.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(input => {
            const propName = input.name.replace(/^properties\[/, '').replace(/\]$/, '');
            if (propName && input.value) {
              properties[propName] = input.value;
            }
          });
        }

        if (variantId) {
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
            });
            document.dispatchEvent(new CustomEvent('cart-update'));
          } catch (err) {
            console.error('Error adding item to cart for COD:', err);
          }
        }

        this.openModal(this.modal);
      }
    });

    // Listen to changes in the cart (to reload data if needed)
    document.addEventListener('cart-update', () => {
      const dialog = this.modal.querySelector('dialog');
      if (dialog && dialog.hasAttribute('open')) {
        this.loadCartData();
      }
    });

    // Listen for native dialog close event to handle resets and drawer reopening
    const dialog = this.modal.querySelector('dialog');
    if (dialog) {
      dialog.addEventListener('close', () => {
        if (!this.isSubmitted) {
          this.form.reset();
          this.clearAlerts();
          const drawer = document.querySelector('cart-drawer, cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            setTimeout(() => {
              drawer.open();
            }, 100);
          }
        }
      });
    }
  }

  openModal(modalElement) {
    const modal = modalElement || this.modal;
    if (!modal) return;
    this.isSubmitted = false;

    if (typeof modal.showDialog === 'function') {
      modal.showDialog();
    } else {
      const nativeDialog = modal.querySelector('dialog');
      if (nativeDialog) {
        if (typeof nativeDialog.showModal === 'function') {
          nativeDialog.showModal();
        } else {
          nativeDialog.setAttribute('open', 'true');
        }
        modal.dispatchEvent(new CustomEvent('dialog:open', { bubbles: true }));
      }
    }

    // Immediately trigger cart load to eliminate any timing delays
    this.loadCartData();
  }

  closeModal(modalElement) {
    const modal = modalElement || this.modal;
    if (!modal) return;
    if (typeof modal.closeDialog === 'function') {
      modal.closeDialog();
    } else {
      const nativeDialog = modal.querySelector('dialog');
      if (nativeDialog) {
        if (typeof nativeDialog.close === 'function') {
          nativeDialog.close();
        } else {
          nativeDialog.removeAttribute('open');
        }
        modal.dispatchEvent(new CustomEvent('dialog:close', { bubbles: true }));
      }
    }
  }

  async loadCartData() {
    this.showLoading();
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      this.cartData = await response.json();
      this.renderOrderSummary();
    } catch (error) {
      console.error('Error loading cart data:', error);
      this.showError('An error occurred while loading your cart details. Please try again.');
    }
  }

  showLoading() {
    this.itemsList.innerHTML = `
      <div class="cod-loading-spinner">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
    this.totalPriceEls.forEach(el => el.textContent = '-- AED');
  }

  renderOrderSummary() {
    const isAr = document.documentElement.lang === 'ar' || window.location.pathname.includes('/ar');
    if (!this.cartData || !this.cartData.items || this.cartData.items.length === 0) {
      this.itemsList.innerHTML = `<div class="cod-empty-msg">${isAr ? 'سلتكِ فارغة حالياً.' : 'Your cart is currently empty.'}</div>`;
      this.totalPriceEls.forEach(el => el.textContent = '0.00 AED');
      this.submitBtn.disabled = true;
      return;
    }

    this.submitBtn.disabled = false;
    this.itemsList.innerHTML = '';
    
    let totalCalculated = 0;

    this.cartData.items.forEach(item => {
      const pricing = getProductPricing(item, this.cartData.items);
      totalCalculated += pricing.linePrice;

      const itemRow = document.createElement('div');
      itemRow.className = 'cod-summary-item';
      
      const itemImg = item.image ? `<img src="${item.image}" alt="${item.product_title || item.title}" class="cod-summary-item__img">` : '';
      const variantTitle = item.variant_title ? `<span class="cod-summary-item__variant">(${item.variant_title})</span>` : '';
      const qtyBadge = `<span class="cod-summary-item__qty">${isAr ? 'الكمية:' : 'Qty:'} ${item.quantity}</span>`;
      const formattedPrice = pricing.linePrice.toFixed(2);

      itemRow.innerHTML = `
        <div class="cod-summary-item__left">
          ${itemImg}
          <div class="cod-summary-item__info">
            <span class="cod-summary-item__name">${item.product_title || item.title}</span>
            ${variantTitle}
            ${qtyBadge}
          </div>
        </div>
        <span class="cod-summary-item__price">${formattedPrice} AED</span>
      `;
      
      this.itemsList.appendChild(itemRow);
    });

    const formattedTotal = totalCalculated.toFixed(2);
    this.totalPriceEls.forEach(el => el.textContent = `${formattedTotal} AED`);
  }

  validateUAEPhone(phone) {
    const cleanPhone = phone.replace(/[\s\-\+\(\)]/g, ''); // strip spaces, dashes, plus, parentheses
    
    // Allow common test patterns for test orders
    if (
      cleanPhone === '12345678' || 
      cleanPhone === '123456789' || 
      cleanPhone.includes('12345') || 
      cleanPhone.includes('00000') ||
      cleanPhone.length < 5
    ) {
      return true;
    }
    
    // Standard UAE Mobile Formats (with optional 971, 00971, or 0)
    // Allows any UAE mobile number starting with 5 (e.g. 50, 52, 54, 55, 56, 58, 59, etc.)
    const uaePhoneRegex = /^(?:971|00971|0)?5\d{8}$/;
    return uaePhoneRegex.test(cleanPhone);
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.clearAlerts();

    const formData = new FormData(this.form);
    const name = formData.get('name');
    const phone = formData.get('phone');
    const emirate = formData.get('emirate');
    const address = formData.get('address');

    const isAr = document.documentElement.lang === 'ar' || window.location.pathname.includes('/ar');

    if (!name) {
      this.showError(isAr ? 'الرجاء إدخال الاسم الكامل' : 'Please enter your name');
      return;
    }

    if (!phone) {
      this.showError(isAr ? 'الرجاء إدخال رقم الهاتف' : 'Please enter your phone number');
      return;
    }

    // Phone format validation
    if (!this.validateUAEPhone(phone)) {
      const phoneInput = this.form.querySelector('.pn-input__phonenumber');
      if (phoneInput) {
        phoneInput.focus();
        phoneInput.dispatchEvent(new Event('blur'));
      }
      this.showError(isAr ? 'الرجاء إدخال رقم هاتف إماراتي صحيح' : 'Invalid number — please enter a valid UAE mobile number');
      return;
    }

    if (!emirate) {
      this.showError(isAr ? 'الرجاء تحديد الإمارة' : 'Please select your Emirate');
      return;
    }

    if (!address) {
      this.showError(isAr ? 'الرجاء إدخال العنوان التفصيلي' : 'Please enter your delivery address');
      return;
    }

    this.setSubmitState(true);

    const tempOrderId = 'RAHATY-' + String(Date.now()).slice(-4);
    
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Dubai' }));
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const date = day + '/' + month + '/' + year;

    // Calculate exact storewide bundle prices for line items and total
    let orderTotal = 0;
    const orderItems = this.cartData.items.map(item => {
      const pricing = getProductPricing(item, this.cartData.items);
      orderTotal += pricing.linePrice;
      return {
        variant_id: item.variant_id || item.id,
        title: item.product_title || item.title,
        variant_title: item.variant_title || '',
        quantity: item.quantity,
        sku: item.sku || '',
        price: pricing.unitPrice.toFixed(2)
      };
    });

    const totalQuantity = orderItems.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 1), 0);

    const orderPayload = {
      date: date,                          // "04/07/2026"
      orderId: tempOrderId,                // "RAHATY-XXXX" (temporary)
      country: 'UAE',                      // always hardcoded
      emirate: emirate,                    // UAE Emirate selection
      address: address.trim(),             // Detailed address / street / villa / apt
      name: name.trim(),                   // customer name
      phone: formatPhone(phone.trim()),    // "9715XXXXXXXX" (no + no spaces)
      product: formatProductNames(this.cartData.items),   // "Arabic Name 1/Arabic Name 2"
      sku: formatSKUs(this.cartData.items),          // "ANQ-001/ANQ-002"
      quantity: formatQuantities(this.cartData.items),    // "2" or "2/1/3"
      total_quantity: totalQuantity,       // exact numeric sum of all pieces
      totalPrice: orderTotal.toFixed(2),  // numeric only: exact discounted total
      currency: 'AED',                     // always hardcoded
      status: '',                          // always empty
      items: orderItems
    };

    try {
      // 1. Update Shopify cart note and attributes
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Customer Name': name.trim(),
            'Customer Phone': formatPhone(phone.trim()),
            'Emirate': emirate,
            'Delivery Address': address.trim(),
            'Payment Method': 'Cash on Delivery (COD)',
            'Total Price': orderTotal.toFixed(2) + ' AED'
          },
          note: `COD Order | Name: ${name.trim()} | Phone: ${formatPhone(phone.trim())} | Emirate: ${emirate} | Address: ${address.trim()} | Total: ${orderTotal.toFixed(2)} AED`
        })
      });

      // 2. POST payload to Google Sheets Webhook
      await fetch(COD_CONFIG.webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify(orderPayload)
      });

      // 3. Clear the Shopify cart using AJAX API
      await fetch('/cart/clear.js', { method: 'POST' });
      
      // Update native Cart Drawer contents visually if possible
      document.dispatchEvent(new CustomEvent('cart-update'));

      this.isSubmitted = true;

      // Store the order payload and unique event ID in sessionStorage
      const eventId = 'EVT-' + Date.now();
      sessionStorage.setItem('rahaty_last_order', JSON.stringify(orderPayload));
      sessionStorage.setItem('rahaty_event_id', eventId);

      // Fire conversion tracking immediately upon successful submission (TikTok: Purchase, SubmitForm, CompleteRegistration, CompletePayment, PlaceAnOrder; Meta; Snap)
      if (window.RahatyPixels && typeof window.RahatyPixels.trackOrderConversion === 'function') {
        window.RahatyPixels.trackOrderConversion(orderPayload, eventId, 'cod_submit');
      } else if (typeof window.firePurchase === 'function') {
        window.firePurchase(orderPayload, eventId);
      }

      // Open upsell popup immediately (no delay)
      const upsellPopup = document.querySelector('#upsell-popup-modal');
      this.closeModal(this.modal);
      if (upsellPopup) {
        this.openModal(upsellPopup);
      } else {
        window.location.href = COD_CONFIG.thankYouPageUrl;
      }

    } catch (error) {
      console.error('Error submitting order to webhook:', error);
      // Fallback: Clear cart and redirect anyway to prevent customer dropoffs
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        
        const fallbackEventId = 'EVT-' + Date.now();
        sessionStorage.setItem('rahaty_last_order', JSON.stringify(orderPayload));
        sessionStorage.setItem('rahaty_event_id', fallbackEventId);

        if (window.RahatyPixels && typeof window.RahatyPixels.trackOrderConversion === 'function') {
          window.RahatyPixels.trackOrderConversion(orderPayload, fallbackEventId, 'cod_fallback');
        } else if (typeof window.firePurchase === 'function') {
          window.firePurchase(orderPayload, fallbackEventId);
        }
        
        const upsellPopup = document.querySelector('#upsell-popup-modal');
        this.closeModal(this.modal);
        if (upsellPopup) {
          this.openModal(upsellPopup);
        } else {
          window.location.href = COD_CONFIG.thankYouPageUrl;
        }
      } catch (e) {
        const isAr = document.documentElement.lang === 'ar';
        this.showError(isAr ? 'حدث خطأ أثناء معالجة طلبكِ. يرجى المحاولة مرة أخرى.' : 'An error occurred while processing your order. Please try again.');
        this.setSubmitState(false);
      }
    }
  }

  setSubmitState(isLoading) {
    const isAr = document.documentElement.lang === 'ar';
    if (isLoading) {
      this.submitBtn.classList.add('loading');
      this.submitBtn.disabled = true;
      const textSpan = this.submitBtn.querySelector('.btn-text');
      if (textSpan) {
        textSpan.textContent = isAr ? '✓ جاري تأكيد طلبكِ...' : '✓ Confirming your order...';
      }
      this.submitBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    } else {
      this.submitBtn.classList.remove('loading');
      this.submitBtn.disabled = false;
      const textSpan = this.submitBtn.querySelector('.btn-text');
      if (textSpan) {
        textSpan.textContent = isAr ? 'تأكيد طلبي' : 'Confirm My Order';
      }
      this.submitBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }
  }

  showError(message) {
    this.errorAlert.textContent = message;
    this.errorAlert.classList.remove('hidden');
    this.errorAlert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  clearAlerts() {
    this.errorAlert.textContent = '';
    this.errorAlert.classList.add('hidden');
  }

  initPhoneValidator() {
    const inp = this.form.querySelector('.pn-input__phonenumber');
    const box = inp ? inp.closest('.form-element') : null;
    if (!inp || !box) return;

    inp.placeholder = '05X XXX XXXX';
    inp.setAttribute('inputmode', 'numeric');
    inp.setAttribute('autocomplete', 'tel-national');

    const isAr = document.documentElement.lang === 'ar' || window.location.pathname.includes('/ar');
    let lastD = '';

    // Arabic/Persian Digit Converter (Fixes empty phone issue for Arabic keyboards)
    function convertDigits(str) {
      return str.replace(/[٠-٩]/g, function(d) {
        return d.charCodeAt(0) - 1632;
      }).replace(/[۰-۹]/g, function(d) {
        return d.charCodeAt(0) - 1776;
      });
    }

    // Helpers
    function getDigits(v) {
      let d = convertDigits(v).replace(/\D/g, '');
      if (d.slice(0,5) === '00971') d = '0' + d.slice(5);
      else if (d.slice(0,3) === '971') {
        const r = d.slice(3);
        d = (r.charAt(0) === '0') ? r : ('0' + r);
      }
      return d.slice(0, 10);
    }

    function fmtPhone(d) {
      if (d.length <= 3) return d;
      if (d.length <= 6) return d.slice(0,3) + ' ' + d.slice(3);
      return d.slice(0,3) + ' ' + d.slice(3,6) + ' ' + d.slice(6,10);
    }

    function isTestBypass(d) {
      return (
        d === '12345678' || 
        d === '123456789' || 
        d.includes('12345') || 
        d.includes('00000') ||
        d.length < 5
      );
    }

    function isValid(d) { 
      return /^05\d{8}$/.test(d) || isTestBypass(d); 
    }

    function badPfx(d) { 
      return d.length >= 2 && d.slice(0,2) !== '05' && !isTestBypass(d); 
    }

    // UI Builders
    function makeDots(count) {
      const s = document.createElement('span');
      s.className = 'fe-dots-ae';
      for (let i = 0; i < 10; i++) {
        const em = document.createElement('em');
        if (i < count) em.className = 'on';
        s.appendChild(em);
      }
      return s;
    }

    function clearUI() {
      box.classList.remove('valid-ae', 'invalid-ae', 'typing-ae');
      const ch = box.querySelector('.fe-check-ae');
      const br = box.querySelector('.fe-bar-ae');
      if (ch) ch.remove();
      if (br) br.remove();
    }

    function showBar(type, html, dots) {
      const div = document.createElement('div');
      div.className = 'fe-bar-ae t-' + type;
      div.setAttribute('dir', 'rtl');

      const span = document.createElement('span');
      span.style.cssText = 'flex:1; unicode-bidi: isolate; text-align: right;';
      span.innerHTML = html;
      div.appendChild(span);

      if (typeof dots === 'number') div.appendChild(makeDots(dots));
      box.appendChild(div);
    }

    function showCheck() {
      const pni = inp.closest('.pn-input') || inp.parentNode;
      
      const ch = document.createElement('div');
      ch.className = 'fe-check-ae';
      ch.innerHTML = `<svg viewBox="0 0 14 11" width="13" height="10" fill="none"><path d="M1.5 5.5L5.5 9.5L12.5 1.5" stroke="white" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      pni.appendChild(ch);
    }

    // Core Logic
    const render = (d, isBlur) => {
      clearUI();
      const len = d.length;
      if (len === 0) return;

      if (isValid(d)) {
        box.classList.add('valid-ae');
        showCheck();
        showBar('success', isAr ? '✅ ممتاز! سيتصل بك فريقنا لتأكيد الطلب' : '✅ Excellent! Our team will contact you to confirm');
      } else if (badPfx(d)) {
        box.classList.add('invalid-ae');
        showBar('error', isAr ? '⚠️ أرقام الهواتف في الإمارات تبدأ بـ <strong>05</strong>' : '⚠️ UAE phone numbers must start with <strong>05</strong>');
      } else if (isBlur && len < 10) {
        box.classList.add('invalid-ae');
        showBar('error', isAr ? '⚠️ الرقم غير مكتمل — يجب أن يتكون من <strong>10</strong> أرقام' : '⚠️ Number incomplete — must be <strong>10</strong> digits');
      } else if (len < 2) {
        box.classList.add('typing-ae');
        showBar('hint', isAr ? '📱 ابدأ الرقم بـ <strong>05</strong>' : '📱 Start the number with <strong>05</strong>');
      } else {
        box.classList.add('typing-ae');
        const rem = 10 - len;
        let msg = '';
        if (isAr) {
          msg = rem === 1 ? 'متبقي رقم واحد ✍️' : 'متبقي <bdi>' + rem + '</bdi> أرقام ✍️';
        } else {
          msg = rem === 1 ? '1 digit remaining ✍️' : rem + ' digits remaining ✍️';
        }
        showBar('progress', msg, len);
      }
    };

    const onInput = () => {
      const old = inp.value;
      const d = getDigits(old);
      const f = fmtPhone(d);

      if (inp.value !== f) {
        inp.value = f;
        try { inp.setSelectionRange(f.length, f.length); } catch(e) {}
      }

      if (d === lastD) return;
      lastD = d;
      render(d, false);
    };

    const onBlur = () => { render(getDigits(inp.value), true); };
    const onFocus = () => { lastD = ''; render(getDigits(inp.value), false); };

    inp.addEventListener('input', onInput);
    inp.addEventListener('blur', onBlur);
    inp.addEventListener('focus', onFocus);
  }

  showSuccess() {
    const modalBody = this.modal.querySelector('.cod-modal__body');
    modalBody.innerHTML = `
      <div class="cod-success-screen">
        <svg class="cod-success-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9 11.5l2.5 2.5 5-5"/>
        </svg>
        <h3 class="cod-success-title">Thank you! Your order was received successfully</h3>
        <p class="cod-success-msg">Our team will call you within 24 hours to confirm your order and arrange delivery.</p>
        <div class="cod-loading-bar"></div>
      </div>
    `;
  }
}

// Instantiate on load
function initCodCheckout() {
  if (!window.CodCheckoutInstance) {
    window.CodCheckoutInstance = new CodCheckout();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCodCheckout);
} else {
  initCodCheckout();
}
